import { GET_SCHEMAS_BY_NAME, GET_SCHEMAS_BY_NAME_EMPTY, GET_SCHEMAS_BY_NAME_ERROR, GET_SCHEMAS_BY_NAME_SUCCESS } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSchemasByName = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEMAS_BY_NAME:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SCHEMAS_BY_NAME_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SCHEMAS_BY_NAME_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SCHEMAS_BY_NAME_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSchemasByName;
